import React from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/layout/Header";
import CookiesBanner from "@/components/cookieBanner/CookiesBanner";

const AuthLayout: React.FC = () => {
  return (
    <>
      <Header />
      <div className="w-full h-[calc(100vh-64px)] flex items-center justify-center">
        <div className="flex items-center justify-center py-12 px-3 ">
          <Outlet />
        </div>
      </div>
      <CookiesBanner />
    </>
  );
};

export default AuthLayout;
